import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import CompteService from '../services/CompteService';


const UpdatePassword = () => {
    const [yesNo, setYesNo] = useState({});
    const [form, setForm] = useState({});
    
    return (
        <div>
            <div className="card">
                <Form {...{form, setYesNo}} />
                <Confirmation {...yesNo} />
            </div>
            
        </div>
    );
}

const Form = (props) => {
    const {visible, hide, data, setData, callback } = props.form;
    const {setYesNo} = props;
    const[loading, setLoading] = useState(false);

    const bind = (e) => {
        if(e.target.value !== undefined) {
            let value = e.target.value;
            setData({...data, [e.target.id]: value});
        } else{
            alert("Binding fails.")
        }
    }
    
    const submit = () => {
        setYesNo(
            {   
                visible: true,
                message : data.id ? "Confirmez-vous la modification ?" : "Confirmez-vous l'ajout ?",
                hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                callback : ()=> {
                    setLoading(true);
                    let onResponse = (data, status)=> {
                            setLoading(false);
                            if(!status) return;
                            hide();
                            callback();
                    }
                    if(data.id) CompteService.updatePassword(data, onResponse);
                },
            }
        )
    }

    return(  
        <div style={{display: 'flex', flexDirection: 'row', height: '80vh', justifyContent: 'center', alignItems: 'center'}}>
            <div className="surface-card p-5 shadow-2 w-full lg:w-6 border-round w-12/12 h-4 ">
            
                <div className="text-center mb-5">
                    {/* <img src="images/blocks/logos/hyper.svg" alt="hyper" height="50" className="mb-3" /> */}
                    <div className="text-900 text-3xl font-medium mb-3">Modifier votre mot de passe</div>
                </div>

                <div className='p-fluid '>
                    <label htmlFor="ancien" className="block text-900 font-medium mb-2">Ancien mot de passe</label>
                    <Password id="ancien" type="text" className="w-full mb-3" toggleMask 
                        required value={data?.oldPassword} onChange={bind}  />
                    
                    <label htmlFor="password" className="block text-900 font-medium mb-2">Nouveau mot de passe</label>
                    <Password inputId="password" className="w-full mb-3" toggleMask 
                        required value={data?.newPassword} onChange={bind}
                         />
                    
                    <Button autoFocus label="Modifier" icon="pi pi-user" iconPos="right" 
                        className="w-full" loading={loading} onClick={submit} />
                
                </div>

            </div>
        </div>
    )
}

const Confirmation = (props) => {
    const {visible, hide, message, callback } = props;
    
    return (
        <Dialog modal visible={visible} onHide={hide} 
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times" 
                        onClick={hide} 
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check" 
                        onClick={() => { hide(); callback() }} 
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

export default UpdatePassword;